var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    color: "var(--blue)",
    viewBox: "-1 -1 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.898 2c1.637 0 3.179.693 4.335 1.881 1.253 1.188 1.927 2.871 1.735 4.555 0 1.683-.675 3.366-1.831 4.554l-8.479 8.713c-.192.198-.385.297-.674.297s-.482-.099-.675-.297L2.831 12.99C1.674 11.802 1 10.12 1 8.436s.674-3.367 1.927-4.555a6.104 6.104 0 0 1 8.768 0l.385.396.386-.396A6.27 6.27 0 0 1 16.898 2M12.08 19.624l7.804-8.02c.867-.891 1.35-1.98 1.35-3.168s-.483-2.278-1.253-3.169c-.868-.792-1.927-1.287-3.084-1.287-1.252 0-2.312.495-3.18 1.287l-.963 1.09a.914.914 0 0 1-1.348 0l-1.06-1.09c-.867-.89-1.927-1.287-3.083-1.287-1.06 0-2.216.396-2.987 1.287s-1.253 1.98-1.253 3.169c0 1.188.386 2.277 1.253 3.168z",
    clipRule: "evenodd"
  })));
};
export default SvgHeart;